// extracted by mini-css-extract-plugin
export default {"row":"slY_CGt8Wf8gs1bZ1eFi"};